import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const NoFlex = styled.div({
  flex: 'none',
  maxWidth: 'calc(66% - 1.4rem)',
  display: 'flex',
});

export const Disableable = comp => {
  const result = styled(comp)(({ disabled }: { disabled?: boolean }) => {
    return css({
      opacity: disabled ? 0.48 : 1,
      cursor: disabled ? 'not-allowed' : undefined,
    });
  });
  return result;
};

export const DisableableDiv = Disableable('div');

export const DisableableSpan = DisableableDiv.withComponent('span');
export const DisableableLabel = DisableableDiv.withComponent('label');
